import request from 'configuration/request';
import { httpBuildQuery } from 'helpers/utils';

export const transferApi = {
  getTransferActHistory: (actID1C) => {
    return request({
      url: `/history/list/?order=${actID1C}`,
      method: 'GET',
    });
  },

  getTransferAct: (actID1C) => {
    return request({
      url: `/transfer_act/${actID1C}/`,
      method: 'GET',
    });
  },

  deleteTransferAct: (actID1C) => {
    return request({
      url: `/transfer_act/${actID1C}/`,
      method: 'DELETE',
    });
  },

  createTransferAct: (data) => {
    return request({
      url: '/transfer_act/create/',
      method: 'POST',
      data,
    });
  },

  updateTransferAct: (id, data) => {
    return request({
      url: `/transfer_act/${id}/update/`,
      method: 'PATCH',
      data,
    });
  },

  getTransferActFiles: (id) => {
    return request({
      url: `/transfer_act/${id}/file/`,
      method: 'GET',
    });
  },

  getTransferActAdditionalInfo: (id) => {
    return request({
      url: `/transfer_act/${id}/additional_info/`,
      method: 'GET',
    });
  },

  getTransferActSubEntities: (id) => {
    return request({
      url: `/transfer_act/${id}/sub_entities/`,
      method: 'GET',
    });
  },

  getAgreementFile: (id) => {
    return request({
      url: `/transfer_act/${id}/agreement_file/`,
      method: 'GET',
    });
  },

  sendViberMessage: (id) => {
    return request({
      url: `/transfer_act/${id}/send_message/`,
      method: 'GET',
    });
  },

  getTransferActStatuses: () => {
    return request({
      url: 'transfer_act_status/list/',
      method: 'GET',
    });
  },

  getTransferActSorted: (query) => {
    return request({
      url: `/transfer_act/list/${httpBuildQuery(query)}`,
      method: 'GET',
    });
  },

  getTransferActAsTable: (query) => {
    return request({
      url: `/transfer_act/list_as_table/${httpBuildQuery(query)}`,
      method: 'GET',
    });
  },

  statistic: (query) => {
    return request({
      url: `/transfer_act/statistic/${httpBuildQuery(query)}`,
      method: 'GET',
    });
  },

  statisticRejectReason: (query) => {
    return request({
      url: `reject_reason/statistic/${httpBuildQuery(query)}`,
      method: 'GET',
    });
  },

  getReservationList: ({ stock, isApproved, archive, startDateTime, endDateTime, sub_queries }) => {
    const query = {
      stockID: stock,
      type: 'reserve',
      isApproved,
      endDateTime_min: startDateTime,
      endDateTime_max: endDateTime,
      sub_queries,
    };

    if (archive) {
      if (isApproved === undefined) {
        query.isApproved_exclude = 0;
      }

      query.ordering = '-startDateTime';
    } else if (!archive) {
      if (isApproved === undefined) {
        query.isApproved = 0;
      }

      query.ordering = 'startDateTime';
    }

    return request({
      url: `/transfer_act/list/${httpBuildQuery(query)}`,
      method: 'GET',
    });
  },

  getRentArchiveList: ({ stock, archive, ...params }) => {
    const query = {
      ...params,
      stockID: stock,
    };

    return request({
      url: `/transfer_act/list/${httpBuildQuery(query)}`,
      method: 'GET',
    });
  },

  getAccrualSubTypes: () => {
    return request({
      url: '/accrual_subtype/list/',
      method: 'GET',
    });
  },

  createAccrual: (data) => {
    return request({
      url: '/accrual/create/',
      method: 'POST',
      data,
    });
  },
};
